// extracted by mini-css-extract-plugin
export var childrenContainer = "_b8-0";
export var virtualScrollArea = "_b8-1";